import * as React from "react";

function SvgGraphDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M12 2.25c5.186 0 9.442 4.053 9.734 9.197l.012.277.004.276a9.715 9.715 0 01-2.633 6.663l-.223.231a9.737 9.737 0 01-6.282 2.837l-.336.015-.276.004c-5.186 0-9.442-4.053-9.734-9.197l-.012-.277L2.25 12c0-5.186 4.053-9.442 9.197-9.734l.277-.012L12 2.25zm-.75 1.534c-4.13.372-7.368 3.78-7.496 7.949l-.004.256.004.255c.126 4.369 3.643 7.872 7.984 8.002l.251.004.255-.004a8.21 8.21 0 005.036-1.905l-5.517-5.518a1.713 1.713 0 01-.341-.481l-.001-.007a.701.701 0 01-.075-.18 1.657 1.657 0 01-.087-.396l-.009-.173V3.784zm8.242 4.755L13.22 12.16l5.12 5.12a8.197 8.197 0 001.905-5.018l.004-.251-.004-.255a8.218 8.218 0 00-.754-3.217z"
        />
        <path
          fill="#98DB69"
          d="M18.74 7.24a8.246 8.246 0 00-5.99-3.456l-.001 6.917 5.99-3.46z"
        />
      </g>
    </svg>
  );
}

export default SvgGraphDuo;
